// extracted by mini-css-extract-plugin
export default {"App":"EmailResetPassword_App__-6-TV","content":"EmailResetPassword_content__viEr7","containerBtn":"EmailResetPassword_containerBtn__A5a6a","email":"EmailResetPassword_email__jI5D6"};